import numbro from 'numbro';
import { transparentize } from 'polished';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GetCalculationCommandResult } from 'src/easyclaim.api.client.typescript/src';
import styled from 'styled-components';

import { Modal } from '../index';

interface CalculationDetailsModalProps {
	isOpen: boolean;
	onClose: () => void;
	easyClaimCalculationResult?: GetCalculationCommandResult;
}

export class CalculationDetailsModal extends React.Component<CalculationDetailsModalProps, {}> {
	constructor(props: CalculationDetailsModalProps) {
		super(props);
	}

	public render() {
		const calculation = this.props.easyClaimCalculationResult!;

		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onClose}
				header={<h2>Szczegóły</h2>}
				footer={
					<button onClick={this.props.onClose}>
						<FormattedMessage id="button.close" />
					</button>
				}
			>
				<>
					{calculation && (
						<Container>
							{/* TODOKG: Check if required */}
							{/* {calculation.spareParts && calculation.spareParts.length > 0 && ( */}
							{calculation.sparePartCosts && (
								<>
									<h3>
										<FormattedMessage id="calculationDetailsModal.spareParts" />
									</h3>
									{/* <CostsPositionsContainer>
										{calculation!.spareParts.map((sp, index) => (
											<CostPosition key={index}>
												<Name>{sp.name}</Name>
												<Amount>{sp.amount && numbro(sp.amount).formatCurrency()}</Amount>
											</CostPosition>
										))}
									</CostsPositionsContainer> */}
									<Total>
										<Name>
											<FormattedMessage id="calculationDetailsModal.total" />
										</Name>
										<Amount>
											{calculation.sparePartCosts &&
												numbro(calculation.sparePartCosts).formatCurrency()}
										</Amount>
									</Total>
								</>
							)}
							{/* {calculation.labourPositions && calculation.labourPositions.length > 0 && ( */}
							{calculation.labourCosts && (
								<>
									<h3>
										<FormattedMessage id="calculationDetailsModal.labourCosts" />
									</h3>
									{/* <CostsPositionsContainer>
										{calculation!.labourPositions.map((sp, index) => (
											<CostPosition key={index}>
												<Name>{sp.name}</Name>
												<Amount>{sp.amount && numbro(sp.amount).formatCurrency()}</Amount>
											</CostPosition>
										))}
									</CostsPositionsContainer> */}
									<Total>
										<Name>
											<FormattedMessage id="calculationDetailsModal.total" />
										</Name>
										<Amount>
											{calculation.labourCosts && numbro(calculation.labourCosts).formatCurrency()}
										</Amount>
									</Total>
								</>
							)}

							{/* {calculation.lacquerPositions && calculation.lacquerPositions.length > 0 && ( */}
							{calculation.lacquerCosts && (
								<>
									<h3>
										<FormattedMessage id="calculationDetailsModal.lacquerCosts" />
									</h3>
									{/* <CostsPositionsContainer>
										{calculation!.lacquerPositions.map((sp, index) => (
											<CostPosition key={index}>
												<Name>{sp.name}</Name>
												<Amount>{sp.amount && numbro(sp.amount).formatCurrency()}</Amount>
											</CostPosition>
										))}
									</CostsPositionsContainer> */}
									<Total>
										<Name>
											<FormattedMessage id="calculationDetailsModal.total" />
										</Name>
										<Amount>
											{calculation.lacquerCosts &&
												numbro(calculation.lacquerCosts).formatCurrency()}
										</Amount>
									</Total>
								</>
							)}
							{/* {calculation.additionalPositions && calculation.additionalPositions.length > 0 && ( */}
							{calculation.additionalCosts && (
								<>
									<h3>
										<FormattedMessage id="calculationDetailsModal.additionalCosts" />
									</h3>
									{/* <CostsPositionsContainer>
										{calculation!.additionalPositions.map((sp, index) => (
											<CostPosition key={index}>
												<Name>{sp.name}</Name>
												<Amount>{sp.amount && numbro(sp.amount).formatCurrency()}</Amount>
											</CostPosition>
										))}
									</CostsPositionsContainer> */}
									<Total>
										<Name>
											<FormattedMessage id="calculationDetailsModal.total" />
										</Name>
										<Amount>
											{calculation.additionalCosts &&
												numbro(calculation.additionalCosts).formatCurrency()}
										</Amount>
									</Total>
								</>
							)}
						</Container>
					)}
				</>
			</Modal>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Amount = styled.div<{ fontSize?: string }>`
	font-size: ${(p) => p.fontSize || '1em'};
	flex-grow: 0;
	flex-shrink: 0;
`;

const Name = styled.div`
	text-transform: uppercase;
	padding-right: 1rem;
	hyphens: auto;
	word-wrap: break-word;
`;

const Total = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 0.5rem;
	padding-bottom: 1.5rem;
`;

const CostPosition = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0.35rem 0;
`;

const CostsPositionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	&:not(:last-child) {
		padding-bottom: 0.5rem;
		border-bottom: 1px solid ${(p) => transparentize(0.8, p.theme.colors.secondary)};
	}
	&:not(:first-child) {
		padding-top: 0.5rem;
	}
`;
